import React from "react";
import { Container } from "@mui/material";
import OffreTemplate from "../components/OffreTemplate";
import SEO from "../components/SEO";
import SeoInternalLinks from "../components/SeoInternalLinks";
import exampleApp1 from "../assets/images/projets/lecozenAdmin1.png";
import exampleApp2 from "../assets/images/projets/hexagoneAdmin1.png";
import imgBureau1 from "../assets/images/imgBureau1.png";
import imgBureau2 from "../assets/images/imgBureau2.png";
import imgBureau3 from "../assets/images/imgBureau3.png";
import imgBureau4 from "../assets/images/imgBureau4.png";

export default function OffreBureauPage() {
  return (
    <>
      <SEO
        title="Logiciel de bureau sur mesure Windows Mac Linux | DigiBuddy"
        description="Conception de logiciels de bureau sur mesure pour automatiser vos tâches internes sur Windows, Mac et Linux."
        keywords="logiciel de bureau sur mesure, application desktop métier, développement desktop Windows Mac Linux, automatisation tâches entreprise"
        url="https://www.digibuddy.fr/logiciel-de-bureau-sur-mesure"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Logiciels de Bureau sur Mesure",
          description:
            "Logiciels de bureau personnalisés pour Windows, Mac et Linux. Applications métier, outils de productivité, automatisation.",
          provider: {
            "@type": "Organization",
            name: "DigiBuddy",
          },
          areaServed: "FR",
          serviceType: "Développement logiciel",
          offers: {
            "@type": "Offer",
            price: "À partir de 6000€",
            priceCurrency: "EUR",
          },
        }}
      />
      <OffreTemplate
        title="Logiciels de bureau qui boostent votre productivité"
        intro="<b>Automatisez vos tâches répétitives avec des outils<br>qui s'intègrent parfaitement à votre environnement de travail.</b><br><br>Vos équipes gagnent du temps et se concentrent sur l'essentiel."
        bannerImage="/images/banner-bureau.jpg"
        url="https://www.digibuddy.fr/logiciel-de-bureau-sur-mesure"
        sections={[
          {
            title: "Automatisez vos processus",
            subtitle: "Vos équipes gagnent 3h par jour",
            paragraph:
              "Nous créons des logiciels de bureau qui automatisent vos tâches répétitives et optimisent vos workflows. De la gestion de fichiers à l'analyse de données, nous développons des outils qui font gagner du temps.",
            bullets: [
              "Traitement automatique de fichiers en masse",
              "Génération automatique de rapports",
              "Synchronisation avec vos logiciels existants",
              "Automatisation des tâches administratives",
            ],
            imageSrc: imgBureau1,
          },
          {
            title: "Interface native et intuitive",
            subtitle: "Vos équipes adoptent immédiatement",
            paragraph:
              "Les applications de bureau offrent une expérience utilisateur riche et réactive. Nous créons des interfaces qui respectent les standards de chaque système tout en restant cohérentes avec votre identité.",
            bullets: [
              "Interface adaptée à Windows, Mac ou Linux",
              "Raccourcis clavier et menus contextuels",
              "Drag & drop et interactions avancées",
              "Thèmes et personnalisation",
            ],
            imageSrc: imgBureau2,
          },
          {
            title: "Performance et fiabilité",
            subtitle: "Vos outils fonctionnent sans interruption",
            paragraph:
              "Les logiciels de bureau offrent des performances élevées et une fiabilité maximale. Vos équipes peuvent travailler sans dépendre d'une connexion internet et sans ralentissements.",
            bullets: [
              "Performance optimisée pour votre matériel",
              "Fonctionnement hors ligne",
              "Pas de dépendance internet",
              "Stabilité et fiabilité maximales",
            ],
            imageSrc: imgBureau3,
          },
          {
            title: "Déploiement et maintenance simplifiés",
            subtitle: "Vos outils évoluent avec vos besoins",
            paragraph:
              "Nous gérons le déploiement de vos applications sur tous les postes de travail. Mises à jour automatiques, gestion des versions et support technique pour garantir la continuité de service.",
            bullets: [
              "Installation automatique sur tous les postes",
              "Mises à jour en arrière-plan",
              "Gestion des versions et rollback",
              "Support technique et documentation",
            ],
            imageSrc: imgBureau4,
          },
        ]}
        galleryImages={[exampleApp1, exampleApp2]}
      />
      <Container sx={{ py: 2 }} style={{ maxWidth: "800px" }}>
        <SeoInternalLinks
          title="À lire aussi"
          links={[
            { to: "/logiciel-metier-sur-mesure", label: "Logiciel métier et application web" },
            { to: "/creation-site-web-sur-mesure", label: "Création de site web sur mesure" },
            { to: "/freelance-ou-agence-pour-creer-son-site", label: "Freelance ou agence ?" },
            { to: "/", label: "Accueil" },
          ]}
        />
      </Container>
    </>
  );
}
